module.exports = __webpack_public_path__ + "static/media/pic_winie_04.dbc1954a.png";